import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {  Cookies } from 'react-cookie';
import ArchiveOrdersOffineBeforPrice from './ArchiveOrdersOffineBeforPrice';
import ArchiveOrdersOffinePriced from './ArchiveOrdersOffinePriced';
import ArchiveOrdersOffineCancelPriced from "./ArchiveOrdersOffineCancelPriced";




const styles = theme => ({
    paperrtl: {
        marginTop: theme.spacing(0),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    }
    , paper: {
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(1),
            width: theme.spacing(20),
        },
    },


});

class ArchiveOrdersOffine extends Component {
    cookies=new Cookies();
    constructor(props) {
        super(props);
        this.state = {
            value:0,
        }}

    componentDidMount() {

    }
    handleChange= (event,newValue) => {
        this.setState({ value:newValue });
    }
    render() {
        const { classes } = this.props;
        const { value } = this.state;

        return (
            <div style={{dir:'rtl',direction: 'rtl'}}>
                <AppBar style={{dir:'rtl'}} position="sticky"color="primary" >

                    <Tabs
                        style={{height:'60px',textAlign:'center',dir:'rtl'}}
                        value={value}
                        onChange={this.handleChange}
                        indicatorColor="secondary"
                        textColor={'#000000'}
                        variant="scrollable"
                        scrollButtons="on"
                        aria-label="scrollable force tabs example"
                    >
                        <Tab label=" درخواست های نرخ گیری"  />
                        <Tab label="درخواست های نرخ داده شده"  />
                        <Tab label="درخواست های انصراف داده شده"  />

                    </Tabs>


                </AppBar>
                {(value==0)?<ArchiveOrdersOffineBeforPrice  props={this.props}/>:null}
                {(value==1)?<ArchiveOrdersOffinePriced  props={this.props}/>:null}
                {(value==2)?<ArchiveOrdersOffineCancelPriced  props={this.props}/>:null}


            </div>
        );
    }
}

export default  withStyles(styles)(ArchiveOrdersOffine);
